import { DefaultState } from 'store/types';

export const CHECK_IF_EXISTS_REQUEST = 'CHECK_IF_EXISTS_REQUEST';
export const CHECK_IF_EXISTS_SUCCESS = 'CHECK_IF_EXISTS_SUCCESS';
export const CHECK_IF_EXISTS_FAILURE = 'CHECK_IF_EXISTS_FAILURE';

export const CHECK_IF_EXISTS_BY_ID_REQUEST = 'CHECK_IF_EXISTS_BY_ID_REQUEST';
export const CHECK_IF_EXISTS_BY_ID_SUCCESS = 'CHECK_IF_EXISTS_BY_ID_SUCCESS';
export const CHECK_IF_EXISTS_BY_ID_FAILURE = 'CHECK_IF_EXISTS_BY_ID_FAILURE';

export interface CheckIfExistsParams {
  guestId: string;
  locationId: string;
  fromDate: string;
  toDate: string;
}

export interface CheckIfExistsMassParams {
  lodgingRequestsIds: string[];
  fromDate: string;
  toDate: string;
  locationId?: string;
}

export interface ExistingRequestData {
  status: string;
  guestId: string;
  jobId: string;
  fromDate: string;
  toDate: string;
}

export interface CheckIfExistsData {
  exists: boolean;
  messageData?:ExistingRequestData | string;
}

export type CheckIfExistsState = DefaultState & {
  exists: boolean;
  existingRequestData?: ExistingRequestData;
};

interface CheckIfExistsRequest {
  type: typeof CHECK_IF_EXISTS_REQUEST;
}

interface CheckIfExistsSuccess {
  type: typeof CHECK_IF_EXISTS_SUCCESS;
  exists: boolean;
  existingRequestData?: ExistingRequestData;
}

interface CheckIfExistsFailure {
  type: typeof CHECK_IF_EXISTS_FAILURE;
}

interface CheckIfExistsByIdRequest {
  type: typeof CHECK_IF_EXISTS_BY_ID_REQUEST;
}

interface CheckIfExistsByIdSuccess {
  type: typeof CHECK_IF_EXISTS_BY_ID_SUCCESS;
  exists: boolean;
  existingRequestData?: ExistingRequestData;
}

interface CheckIfExistsByIdFailure {
  type: typeof CHECK_IF_EXISTS_BY_ID_FAILURE;
}

export type CheckIfExistsActionTypes =
  | CheckIfExistsRequest
  | CheckIfExistsSuccess
  | CheckIfExistsFailure
  | CheckIfExistsByIdRequest
  | CheckIfExistsByIdSuccess
  | CheckIfExistsByIdFailure;
